import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { UserResponse } from '../types';
import { showNotification } from '@/utils/notificationUtils';

export type ForgotPasswordCredentialsDTO = {
    email: string
};

export const forgotPasswordandReset = (data: ForgotPasswordCredentialsDTO): Promise<UserResponse> => {

    return axios.post('/business/password/reset', data);
};

type UseUpdateBusinessOptions = {
    config?: MutationConfig<typeof forgotPasswordandReset>;
};

export const useForgotPassword = ({ config }: UseUpdateBusinessOptions = {}) => {
    return useMutation({
        ...config,
        onSuccess: () => {
            showNotification({
                type: 'success',
                title: 'Please check your email for resetting your password.',
            });
        },
        mutationFn: forgotPasswordandReset,
    });
};
